import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

const URI = 'https://www.cpem41.edu.ar/backend.php/session.php'; 

const Iniciarsession = () => {
    
    const [credentials, setCredentials] = useState({ username: '', password: '' })


const inicioSession = async () => {
  try {
    const formData = new URLSearchParams()
    formData.append('username', credentials.username)
    formData.append('password', credentials.password)

    const response = await axios.post(URI, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      withCredentials: true // 👈 importante para enviar/recibir cookies
    })

    const usuario = response.data.user

    if (usuario) {
      localStorage.setItem("user", usuario)
      window.location.href = '#/usuariosphp/Panel'
    } else {
      Swal.fire({
        title: 'Error',
        text: 'Usuario y/o contraseña incorrectos',
        icon: 'error',
      })
    }

  } catch (error) {
    console.error('Error en la solicitud:', error)
    Swal.fire({
      title: 'Error',
      text: 'Hubo un problema al iniciar sesión...',
      icon: 'error',
    })
  }
}


  return ( 
    <div>
      <div className="seccion_menu">
        <div className="seccion">

          <h2>CPEM N°41</h2>        
                    
          <div className='modal-content'>
                <h1>Iniciar sesión</h1>
                <div>
                    <input
                        type="text"
                        placeholder="Nombre de usuario"
                        value={credentials.username}
                        onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
                    />
                </div>
                <div>
                    <input
                        type="password"
                        placeholder="Contraseña"
                        value={credentials.password}
                        onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                    />
                </div>
                <div className='boxinput'>
                    <button onClick={inicioSession} className='btn' type='submit'>ACCESS</button>
                </div>
            </div>


        </div>
      </div>

    </div>
  )

};

export default Iniciarsession;
